const suggestions = [
    {
        name: 'Resources',
        id: '1',
        url: 'https:mysite.com/resources',
    },
    {
        name: 'Early Childcare',
        id: '2',
        url: 'https:mysite.com/early-childcare',
    },
    {
        name: 'Road Safety Victoria',
        id: '3',
        url: 'https:mysite.com/road-safety-victoria',
    },
    {
        name: 'Programs',
        id: '4',
        url: 'https:mysite.com/programs',
    },
    {
        name: 'Secondary School',
        id: '5',
        url: 'https:mysite.com/secondary-school',
    },
];

export default suggestions;
